export default __webpack_public_path__ + "f010e5b4ef25bea6c5fb3d078dc21264.wav";